export class OfficeEquipmentModelResult {
    public id: number = 0;
    public name: string = '';
    public officeEquipmentBrandId: number = 0;
    public officeEquipmentBrandName: string = '';
    public officeEquipmentTypeId: number = 0;
    public officeEquipmentTypeName: string = '';
    public isDeleted: boolean = false;

    // front-end
    public completeName = '';
}
